import { MainSettingsItem } from '../models/user';
import { MainSettingsEnum } from '../models/enums/mainSettings.enum';

export const getMainSetting = (mainSettings: MainSettingsItem[], key: MainSettingsEnum, defaultLabel: string) => {
  const foundSetting = mainSettings?.find((x) => x.key === key);

  return (foundSetting && foundSetting.value) || defaultLabel;
};
